const forItems = [
  {
    icon: 'ri-user-star-fill',
    title: 'The sophomore or junior athlete',
    desc: "You're talented, you're putting in the work — but nobody's shown you how the recruiting game actually works.",
  },
  {
    icon: 'ri-parent-fill',
    title: 'The parent who wants to help',
    desc: "You don't want to make costly mistakes or miss critical windows. You want a proven roadmap, not guesswork.",
  },
  {
    icon: 'ri-trophy-fill',
    title: 'The athlete who has been overlooked',
    desc: "Coaches aren't coming to you — so you need to learn how to go to them the right way.",
  },
  {
    icon: 'ri-calendar-check-fill',
    title: 'The freshman just getting started',
    desc: "Starting early is the biggest advantage. This system walks you through every step, year by year.",
  },
  {
    icon: 'ri-money-dollar-circle-fill',
    title: 'The family that needs scholarship money',
    desc: "Athletic scholarships are real — but only for athletes who know how to position themselves to earn one.",
  },
  {
    icon: 'ri-team-fill',
    title: 'Any NCAA sport, any division',
    desc: "D1, D2, D3, NAIA — the recruiting process follows the same playbook. This works across every sport.",
  },
];

const notForItems = [
  'Athletes who already have offers and a signed LOI',
  'Families relying entirely on a coach or agent to handle everything',
  'Athletes not willing to put in effort on and off the field',
];

export default function WhoItsForSection() {
  return (
    <section id="who-its-for" className="bg-[#0c1a30] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#f5a623]/10 border border-[#f5a623]/30 rounded-full px-4 py-2 mb-6">
            <i className="ri-focus-3-line text-[#f5a623] text-sm" />
            <span className="text-[#f5a623] font-body text-xs font-semibold uppercase tracking-widest">Is This For You?</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white uppercase leading-tight">
            This Was Built
            <span className="block text-[#f5a623]">For Athletes Like You</span>
          </h2>
          <p className="font-body text-lg text-white/60 max-w-2xl mx-auto mt-4">
            If any of the following describe you or your family, this playbook was made exactly for your situation.
          </p>
        </div>

        {/* "This IS for" grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-14">
          {forItems.map((item) => (
            <div
              key={item.title}
              className="group bg-[#122040] border border-white/8 rounded-2xl p-6 flex gap-4 items-start hover:border-[#f5a623]/40 transition-all duration-300"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#f5a623]/10 flex-shrink-0 group-hover:bg-[#f5a623]/20 transition-colors duration-300">
                <i className={`${item.icon} text-[#f5a623] text-xl`} />
              </div>
              <div>
                <div className="flex items-center gap-2 mb-1.5">
                  <i className="ri-checkbox-circle-fill text-[#f5a623] text-base" />
                  <h3 className="font-display text-sm font-bold text-white uppercase tracking-wide">{item.title}</h3>
                </div>
                <p className="font-body text-sm text-white/55 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="flex items-center gap-4 mb-10 max-w-xl mx-auto">
          <div className="flex-1 h-px bg-white/10" />
          <span className="font-body text-xs text-white/30 uppercase tracking-widest whitespace-nowrap">But honestly, this is NOT for everyone</span>
          <div className="flex-1 h-px bg-white/10" />
        </div>

        {/* "This is NOT for" list */}
        <div className="max-w-2xl mx-auto bg-[#122040]/60 border border-white/8 rounded-2xl p-6 md:p-8">
          <ul className="flex flex-col gap-4">
            {notForItems.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-close-circle-fill text-red-400/70 text-lg" />
                </div>
                <span className="font-body text-sm text-white/50">{item}</span>
              </li>
            ))}
          </ul>
          <p className="font-body text-sm text-white/40 mt-6 pt-5 border-t border-white/8 text-center">
            If you checked any of the boxes above — you're in the right place. <strong className="text-white/70">Keep reading.</strong>
          </p>
        </div>

      </div>
    </section>
  );
}
